module.exports = __webpack_public_path__ + "media/images/icons/sprite-47e92acbd19cad7af384e6a0fb600ee1.png";